import { CompanyProfileFormModel } from 'src/Libs/company-settings/models'
import { CompanyLocationUpdateDto } from 'src/Libs/company-settings/dto/company-location-update.dto'

const companyProfileFormToLocationDto = (model: CompanyProfileFormModel): CompanyLocationUpdateDto => {
  return {
    Address: model.place,
    Telefax: model.fax,
    Land: model.country,
    Telefon: model.phone,
    PlaceOR: model.address,
    PLZ: model.zipCode,
  }
}
export default companyProfileFormToLocationDto
